<template>
  <div>
    <div class="input__container">
      <input
        class="input input--border input--radius padding__r--42"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        v-model="model"
        @blur="handleInputBlurred()"
      >

      <button
        type="button"
        class="input__btn color--lg"
        :disabled="disabled"
        :aria-label="ariaLabel"
        :aria-pressed="isPasswordType"
        @click.prevent="handleClickButton()"
      >
        <fa-icon
          :icon="icon"
          fixed-width
        />
      </button>
    </div>

    <p
      class="input--errors input--error"
      v-if="v?.$error"
    >
      <template v-if="v.required?.$invalid">
        {{ t('errors.input_password_required') }}
      </template>

      <template v-else-if="v.minLength?.$invalid">
        {{ t('errors.input_password_min_length_8') }}
      </template>

      <template v-else-if="v.sameAs?.$invalid">
        {{ t('errors.input_password_wrong_validation') }}
      </template>
    </p>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from '@/vendors/i18n'

const model = defineModel({ type: String, default: '' })

const { v } = defineProps({
  id: String,
  placeholder: { type: String, default: '*********' },
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  v: Object
})

const { t } = useI18n()

const type = ref('password')

const isPasswordType = computed(() => type.value === 'password')
const icon = computed(() => isPasswordType.value ? ['far', 'eye'] : ['far', 'eye-slash'])
const ariaLabel = computed(() => isPasswordType.value ? t('literal.show_password') : t('literal.hide_password'))

const handleClickButton = () => type.value = isPasswordType.value ? 'text' : 'password'
const handleInputBlurred = () => v.value?.$touch()
</script>

<style lang="scss" scoped>
.input {
  &__btn {
    padding: 3px;
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);

    &:focus {
      outline: 1px dashed $lg;
      outline-offset: 5px;
    }

    &:disabled {
      display: none;
    }
  }
}
</style>
